import React, { Component, useEffect, useState } from "react";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import Company from "../../core/models/company";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import User from "../../core/models/user";
import _, { find } from "lodash";
import "react-multi-carousel/lib/styles.css";
import Content from "../common/home/Content";
import { Stats, StatsMessage } from "../common/home/Stats";
import { useTranslation } from "react-i18next";
import { setLoading } from "../../core/feature/config/configSlice";
import { getBcData, getNotifData } from "../../core/service/api_notification";
import moment from "moment";
import { Transition } from "@headlessui/react";
import { BackButton } from "../common/BackButton";
import CustomApp from "../../core/models/customApp";
import Config from "../../config/Config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import banner from "../../assets/images/icon_stock/banner.png";
import "swiper/css/autoplay";
import { isDarkColor } from "../../config/DarkColorChecker";

const MessageWeb = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const company: Company = useAppSelector((state) => state.company.company);
  const user: User = useAppSelector((state) => state.user.user);
  const { t } = useTranslation();
  const location = useLocation();
  const [pageI, setPageI] = useState(0);
  const [sizeI, setSizeI] = useState(10);
  const [pageB, setPageB] = useState(0);
  const [sizeB, setSizeB] = useState(5);
  const [totalI, setTotalI] = useState(0);
  const [totalB, setTotalB] = useState(0);
  const { cid } = useParams();
  const [pesan, setPesan] = useState<any>([]);
  const [broadcast, setBroadcast] = useState<any>([]);
  const [pathName, setPathName] = useState(
    location.pathname.replaceAll("/", "").toUpperCase()
  );
  const [showDetail, setShowDetail] = useState(false);
  const [detailIn, setDetailIn] = useState<any>([]);
  const [showPesan, setShowPesan] = useState(true);
  const [showBroadcast, setShowBroadcast] = useState(false);
  const [detailBroadcast, setDetailBroadcast] = useState<any>([]);
  const [showDetailBroadcast, setShowDetailBroadcast] = useState(false);
  const [inbox, setInbox] = useState(true);
  const env = Config.BaseUrlDev;

  useEffect(() => {
    getPesan();
  }, []);

  const getPesan = () => {
    dispatch(setLoading(true));
    getNotifData(pageI, sizeI)
      .then((res: any) => {
        console.log(res.data);
        setPageI(res.data.page);
        setSizeI(res.data.size);
        setTotalI(res.data.totalElements);
        setPesan(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const changePagePesan = (newPage: any) => {
    setPageI(newPage);
    dispatch(setLoading(true));
    getNotifData(newPage, sizeI)
      .then((res: any) => {
        console.log(res.data);
        setPesan(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const changePageBroadcast = (newPage: any) => {
    setPageB(newPage);
    dispatch(setLoading(true));
    getBcData(newPage, sizeB)
      .then((res: any) => {
        console.log(res.data);
        setBroadcast(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const changeSizePesan = (newSize: any) => {
    setSizeI(newSize);
    dispatch(setLoading(true));
    getNotifData(0, newSize)
      .then((res: any) => {
        console.log(res.data);
        dispatch(setLoading(false));
        setPesan(res.data.content);
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const changeSizeBroadcast = (newSize: any) => {
    setSizeB(newSize);
    dispatch(setLoading(true));
    getBcData(pageB, newSize)
      .then((res: any) => {
        console.log(res.data);
        dispatch(setLoading(false));
        setBroadcast(res.data.content);
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const detailInfo = async (item: any) => {
    setShowDetail(true);
    setDetailIn(item);
    console.log(item);
  };

  const detailBC = async (item: any) => {
    setShowDetailBroadcast(true);
    setDetailBroadcast(item);
    console.log(item);
  };

  const btnNotif = async () => {
    setShowPesan(true);
    setShowBroadcast(false);
    dispatch(setLoading(true));
    getNotifData(pageI, sizeI)
      .then((res: any) => {
        console.log(res.data);
        setPageI(res.data.page);
        setSizeI(res.data.size);
        setTotalI(res.data.totalElements);
        setPesan(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const btnBroadcast = async () => {
    setShowBroadcast(true);
    setShowPesan(false);
    dispatch(setLoading(true));
    getBcData(pageB, sizeB)
      .then((res: any) => {
        console.log(res, "broadcast");
        setPageB(res.data.page);
        setSizeB(res.data.size);
        setTotalB(res.data.totalElements);
        setBroadcast(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  return (
    <div className="bg-psp-primary mb-8 font-montserrat pb-20">
      <StatsMessage />
      <div className="container z-50 relative w-full bg-white rounded-xl -mt-40 shadow p-4">
        <h2 className="font-bold">{t("MESSAGE.title")}</h2>
        <div className="my-3">
          <button
            onClick={() => btnNotif()}
            style={
              showPesan === true
                ? {
                    backgroundColor: customApp?.app_accent_color,
                    color: isDarkColor(customApp?.app_accent_color)?'white':'black',
                  }
                : { color: "rgb(148 163 184 / var(--tw-text-opacity))" }
            }
            className={`py-2 text-slate-400 rounded-xl border w-40 focus:text-white  mr-3`}
          >
            {t("MESSAGE.button1")}
          </button>
          <button
            onClick={() => btnBroadcast()}
            style={
              showPesan !== true
                ? {
                    backgroundColor: customApp?.app_accent_color,
                    color: isDarkColor(customApp?.app_accent_color)?'white':'black',
                  }
                : { color: "rgb(148 163 184 / var(--tw-text-opacity))" }
            }
            className={`py-2 text-slate-400 rounded-xl border w-40 focus:text-white  mr-3`}
          >
            {t("MESSAGE.button2")}
          </button>
        </div>
        {/*Pesan*/}
        {showPesan ? (
          <div
            className="p-2"
            style={{
              zIndex: 1,
              transition: "0.7s",
            }}
          >
            {pesan.map((item: any, index: any) => {
              return (
                <div key={index}>
                  <div
                    onClick={() => detailInfo(item)}
                    className="grid grid-flow-col border rounded-xl py-2 px-3 mb-4 hover:bg-slate-100 cursor-pointer"
                  >
                    <div className="flex flex-col">
                      <span
                        className={
                          item.readStatus === "UNREAD"
                            ? "font-bold"
                            : "font-normal"
                        }
                      >
                        {item.title}
                      </span>
                      <span
                        className="text-slate-500 cursor-pointer"
                        dangerouslySetInnerHTML={{ __html: item.message }}
                      ></span>
                    </div>
                    <div className="justify-end text-end text-slate-400">
                      <span>
                        {moment(item.createdTime).format("DD MMMM YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="flex relative mt-10 justify-between">
              <div className="pt-2 w-1/4">
                <p>
                  {t("OTHER.showing")} {pageI + 1} {t("OTHER.to")} {sizeI} of{" "}
                  {totalI} data
                </p>
              </div>
              <div className="w-auto">
                <div className="">
                  <select
                    onChange={(value) => {
                      changeSizePesan(value.target.value);
                    }}
                    value={sizeI}
                    className="py-2 border rounded-lg bg-white"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={1000}>1000</option>
                  </select>
                  <span className="ml-1">{t("OTHER.entry")}</span>
                </div>
              </div>
              <div className="flex w-1/4">
                <button
                  onClick={() => changePagePesan(pageI - 1)}
                  disabled={pageI === 0}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  {t("OTHER.previous")}
                </button>
                <button
                  onClick={() => changePagePesan(pageI + 1)}
                  disabled={(pageI + 1) * sizeI > totalI}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  {t("OTHER.next")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="p-2"
            style={{
              zIndex: 1,

              transition: "0.7s",
            }}
          >
            {broadcast.map((item: any, index: any) => {
              console.log(broadcast, "njajal");
              const a = () => {
                if (item.message.length > 250)
                  return `${item.message.substring(0, 250)}...`;
                else return item.message;
              };
              return (
                <div
                  onClick={() => detailBC(item)}
                  key={index}
                  className="cursor-pointer relative border rounded-xl my-2 hover:bg-slate-100"
                >
                  <div>
                    <div className="flex rounded-xl py-2 px-3 cursor-pointer">
                      <div className="flex flex-col">
                        <span className="font-bold text-xl">{item.title}</span>
                        <span className="text-slate-500 text-sm hidden">
                          {t("BROADCAST.from")} :{" "}
                          {moment(item.startTime).format("DD/MM/YYYY, HH : mm")}
                        </span>
                        <span className="text-slate-500 text-sm hidden">
                          {t("BROADCAST.until")} :{" "}
                          {moment(item.endTime).format("DD/MM/YYYY, HH : mm")}
                        </span>
                      </div>
                      <div className="absolute right-3 text-slate-400">
                        <span>
                          {moment(item.createTime).format("DD MMMM YYYY")}
                        </span>
                      </div>
                    </div>
                  </div>
                  {item.message === "" ? null : (
                    <div className="bg-blue-500 m-3 p-3 rounded-xl">
                      <span
                        className="text-white cursor-pointer"
                        dangerouslySetInnerHTML={{
                          __html: item.message,
                        }}
                      ></span>
                    </div>
                  )}
                  {item.imagesFirebase.length === 0 ? null : (
                    <div className="w-full">
                      <Swiper
                        autoplay={true}
                        pagination={{
                          clickable: true,
                          type: "fraction",
                        }}
                        navigation
                        slidesPerView={1}
                        modules={[Pagination, Navigation, Autoplay]}
                      >
                        {item.imagesFirebase.map((res: any, index: any) => {
                          return (
                            <SwiperSlide key={index}>
                              <img
                                src={res}
                                alt=""
                                className="w-auto max-w-[35vw] max-h-[35vh] flex mx-auto rounded-2xl p-3"
                              />
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                    </div>
                  )}
                </div>
              );
            })}
            <div className="flex relative mt-10 justify-between">
              <div className="pt-2 w-1/4">
                <p>
                  {t("OTHER.showing")} {pageB + 1} {t("OTHER.to")} {sizeB} of{" "}
                  {totalB} data
                </p>
              </div>
              <div className="w-auto">
                <div className="">
                  <select
                    onChange={(value) => {
                      changeSizeBroadcast(value.target.value);
                    }}
                    value={sizeB}
                    className="py-2 border rounded-lg bg-white"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={1000}>1000</option>
                  </select>
                  <span className="ml-1">{t("OTHER.entry")}</span>
                </div>
              </div>
              <div className="flex w-1/4">
                <button
                  onClick={() => changePageBroadcast(pageB - 1)}
                  disabled={pageB === 0}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  {t("OTHER.previous")}
                </button>
                <button
                  onClick={() => changePageBroadcast(pageB + 1)}
                  disabled={(pageB + 1) * sizeB > totalB}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  {t("OTHER.next")}
                </button>
              </div>
            </div>
          </div>
        )}
        {/*Broadcast*/}

        <Transition
          show={showDetail}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 in-w-[400px] mx-auto max-w-3xl">
                <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <div className="flex flex-col">
                      <div className="text-center">
                        <p className="text-2xl font-bold">{detailIn.title}</p>
                        <span>
                          {t("MESSAGE.date") +
                            moment(detailIn.createdTime).format("DD MMMM YYYY")}
                        </span>
                        <br />
                        <span>
                          {moment(detailIn.createdTime).format("HH : mm")}
                        </span>
                      </div>
                    </div>
                    <div className="mt-4">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: String(detailIn.message).replace(
                            "******",
                            detailIn.content
                          ),
                        }}
                      ></span>
                    </div>
                    <div className="flex justify-center">
                      <button
                        onClick={() => setShowDetail(false)}
                        className="text-white w-40 bg-red py-2.5 rounded-xl mt-3"
                      >
                        {t("OTHER.close")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>

        <Transition
          show={showDetailBroadcast}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="flex w-auto min-w-[700px] my-6 mx-auto">
                <div className="border-0 rounded-2xl shadow-lg relative max-w-4xl flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <div className="flex flex-col">
                      <div className="text-left">
                        <p className="text-2xl font-bold">
                          {detailBroadcast.title}
                        </p>
                        <p className="text-xl font-semibold">
                          {detailBroadcast.subtitle}
                        </p>
                        <span className="hidden">
                          {t("BROADCAST.from") +
                            " : " +
                            moment(detailBroadcast.startTime).format(
                              "DD/MM/YYYY, HH : mm"
                            )}
                        </span>
                        <br />
                        <span className="hidden">
                          {t("BROADCAST.until") +
                            " : " +
                            moment(detailBroadcast.endTime).format(
                              "DD/MM/YYYY, HH : mm"
                            )}
                        </span>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: detailBroadcast.message,
                        }}
                      ></div>
                    </div>
                    {detailBroadcast.imagesFirebase === "" ? (
                      <div></div>
                    ) : (
                      <Swiper
                        autoplay={true}
                        pagination={{ clickable: true, type: "fraction" }}
                        navigation
                        slidesPerView={1}
                        modules={[Pagination, Navigation, Autoplay]}
                      >
                        {detailBroadcast.imagesFirebase?.map(
                          (a: any, i: any) => {
                            return (
                              <SwiperSlide>
                                <img
                                  key={i}
                                  src={a}
                                  alt=""
                                  className="max-h-[29vw] rounded-xl flex mx-auto object-fill"
                                ></img>
                              </SwiperSlide>
                            );
                          }
                        )}
                      </Swiper>
                    )}
                    <div className="flex justify-center">
                      <button
                        onClick={() => setShowDetailBroadcast(false)}
                        className="text-white w-40 bg-red py-2.5 rounded-xl mt-4"
                      >
                        {t("OTHER.close")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>
      </div>
    </div>
  );
};

export default MessageWeb;
